exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iXJz {\n    text-align: center;\n    font-size: 16px;\n    line-height: 22px;\n    margin-bottom: 15px;\n    padding: 0 20px;\n}\n", ""]);

// exports
exports.locals = {
	"degree": "iXJz"
};